import classNames from 'classnames'
import {memo, useContext, useEffect, useState} from 'react'

import type {BuildId} from '../../../../../types'
import {
  PipelinesTarget,
  PipelinesTargetContext,
} from '../../../../pages/PipelinesPages/contexts/targetContext'
import {FullLogTarget} from '../../BuildLog.types'
import {TargetContext} from '../FullBuildLog.context'

import BuildLogControls from './BuildLogControls/BuildLogControls'
import BuildLogSearch from './BuildLogSearch/BuildLogSearch'

import styles from './BuildLogCompactHeader.css'

type Props = {
  buildId: BuildId
}

function BuildLogCompactHeader({buildId}: Props) {
  const target = useContext(TargetContext)
  const pipelinesTarget = useContext(PipelinesTargetContext)
  const [searchActive, setSearchActive] = useState(false)
  useEffect(() => setSearchActive(false), [buildId])

  return (
    <div
      className={classNames(styles.header, {
        [styles.pageTarget]: target === FullLogTarget.PAGE,
        [styles.jobDetailsPopupTarget]: pipelinesTarget === PipelinesTarget.JOB_DETAILS_POPUP,
        [styles.jobDetailsSidebarTarget]: pipelinesTarget === PipelinesTarget.JOB_DETAILS_SIDEBAR,
      })}
    >
      {searchActive ? (
        <BuildLogSearch setSearchActive={setSearchActive} />
      ) : (
        <BuildLogControls buildId={buildId} setSearchActive={setSearchActive} />
      )}
    </div>
  )
}

export default memo(BuildLogCompactHeader)
